import axios from './axios';

export interface CreateCompanyDto {
  name: string;
  phone: string;
  city: string;
  sector: string;
  license: {
    isActive: boolean;
    expiryDate: string;
  };
}

export interface UpdateCompanyDto {
  name?: string;
  phone?: string;
  city?: string;
  sector?: string;
  license?: {
    type: 'trial' | 'premium';
    count: number;
    isActive: boolean;
    expiryDate: string;
  };
}

export const companyService = {
  // Tüm firmaları getir
  async getAllCompanies() {
    try {
      const response = await axios.get('/companies');
      console.log('API getAllCompanies yanıtı:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching companies:', error);
      throw error;
    }
  },

  // Firma detayı getir
  async getCompany(id: string) {
    try {
      const response = await axios.get(`/companies/${id}`);
      console.log(`API getCompany(${id}) yanıtı:`, response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching company:', error);
      throw error;
    }
  },

  // Yeni firma oluştur
  async createCompany(data: CreateCompanyDto) {
    try {
      const response = await axios.post('/companies', data);
      return response.data;
    } catch (error) {
      console.error('Error creating company:', error);
      throw error;
    }
  },

  // Firma güncelle
  async updateCompany(id: string, data: UpdateCompanyDto) {
    try {
      // Veriyi API'nin beklediği formata dönüştür
      const formattedData = {
        ...data,
        license: data.license ? {
          type: data.license.type,
          count: data.license.count,
          isActive: Boolean(data.license.isActive), 
          expiryDate: data.license.expiryDate
        } : undefined
      };
      
      console.log('API Request Data:', formattedData); 
      const response = await axios.patch(`/companies/${id}`, formattedData);
      console.log('API Response:', response.data); 
      
      return response.data.data.company; 
    } catch (error) {
      console.error('Error updating company:', error);
      throw error;
    }
  },

  // Firma sil
  async deleteCompany(id: string) {
    try {
      const response = await axios.delete(`/companies/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting company:', error);
      throw error;
    }
  },

  // Lisans güncelle
  async updateLicense(id: string, data: { isActive: boolean; expiryDate: string }) {
    try {
      const response = await axios.patch(`/companies/${id}/license`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating license:', error);
      throw error;
    }
  },
  
  // Yönetici giriş token'ı al
  async getLoginToken(managerId: string) {
    try {
      console.log('getLoginToken başlatıldı:', { managerId });
      const response = await axios.post(`/auth/managers/${managerId}/login-token`);
      console.log('Login token yanıtı:', { 
        status: response.status, 
        hasData: !!response.data,
        tokenExists: !!response.data?.token || !!response.data?.data?.token
      });
      return response.data;
    } catch (error) {
      console.error('Error getting login token:', error);
      throw error;
    }
  }
};
